<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 text-center udn-table-header">
      <h6>Ciclo de Conversion de efectivo = {{ cashConvertionRate }}</h6>
    </div>

    <div class="md-layout-item md-layout">
      <md-table
        class="udn-table md-layout-item md-medium-size-50 md-small-size-33 md-xsmall-size-100"
        v-for="col in report"
        :key="col.name"
      >
        <md-table-row :class="`udn-${col.color}-header`">
          <md-table-head :colspan="!!col.days ? 1 : 2">
            <h6 class="status-header">{{ col.name }}</h6>
          </md-table-head>
          <md-table-head class="text-right" v-if="col.days">
            <h6 class="status-header">{{ col.days | rounded }}</h6>
          </md-table-head>
        </md-table-row>

        <template v-for="row in col.data">
          <md-table-row :class="`udn-${row.color || col.color}-header`">
            <md-table-cell :colspan="row.sinisters && !!row.sinisters ? 1 : 2">
              <h6 class="data-header">{{ row.name }}</h6>
            </md-table-cell>
            <md-table-cell v-if="row.sinisters && !!row.sinisters">
              <strong> SIN </strong>
            </md-table-cell>
          </md-table-row>

          <md-table-row :class="`udn-${row.color || col.color}`">
            <md-table-cell>
              {{ row.total | money }}
            </md-table-cell>
            <md-table-cell>
              <template v-if="row.sinisters">
                {{ row.sinisters | rounded }}
              </template>
            </md-table-cell>
          </md-table-row>

          <md-table-row class="row-spacer">
            <md-table-cell class="empty-cell" />
          </md-table-row>
        </template>

        <md-table-row v-if="!col.data || !col.data.length" class="empty-row">
          <md-table-cell colspan="2" class="empty-cell">
            <loading-content
              class="empty-column"
              :class="`udn-${col.color}`"
              empty-icon="vertical_split"
              empty-description="Pruebe redefiniendo su consulta o vuelva a intentar tarde."
            />
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>
export default {

  name: 'UDNTable',

  props: {
    report: {
      type: Array,
      required: true,
    },
  },

  filters: {
    rounded: (n) => Math.round(n*100)/100
  },

  data () {
    return {
      cashConvertionRate: 175,
    }
  }
}
</script>

<style lang="css" scoped>
.row-spacer,
.empty-cell {
  height: 10px;
}

.status-header {
  font-size: 14px !important;
  font-weight: bold;
}

.data-header {
  font-weight: bold;
}

.empty-column {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
  max-height: 100vh;
  max-width: 100%;
  overflow: auto;
}

.empty-cell,
.empty-row {
  max-height: 100vh;
  overflow: auto;
}
</style>

<style lang="css" scoped>
.udn-table,
.udn-table.md-table .md-content.md-table-content {
  max-height: 65vh !important;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/Reports/UDNReport/UDNTable.vue